import React, { useState } from 'react';
import { Box, Paper, TextField, Button, Typography, Alert, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { requestPasswordReset } from '../services/authService';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await requestPasswordReset(email);
      setSubmitted(true);
    } catch (error) {
      console.error(error);
      setSubmitted(true); 
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ 
        minHeight: '100vh', 
        bgcolor: '#1a1a1a', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center' 
    }}>
      <Paper sx={{ p: 4, maxWidth: 400, width: '100%', bgcolor: '#f9f9f9' }}>
        <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1a1a1a' }}>
          Reset Password
        </Typography>
        
        {!submitted ? (
          <form onSubmit={handleSubmit}>
            <Typography variant="body2" sx={{ mb: 3, color: '#666' }}>
              Enter your email address and we'll send you a link to reset your password.
            </Typography>
            
            <TextField
              fullWidth
              label="Email Address"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              sx={{ mb: 3 }}
            />
            
            <Button 
              fullWidth 
              variant="contained" 
              type="submit" 
              disabled={loading}
              sx={{ bgcolor: '#a8851d', '&:hover': { bgcolor: '#8c6e18' }, py: 1.5 }}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </Button>
          </form>
        ) : (
          <Box textAlign="center">
            <Alert severity="success" sx={{ mb: 3 }}>
              If an account exists for <strong>{email}</strong>, you will receive an email with instructions shortly.
            </Alert>
            <Button variant="outlined" onClick={() => setSubmitted(false)}>
              Try another email
            </Button>
          </Box>
        )}

        <Box sx={{ mt: 3, textAlign: 'center' }}>
          <Link 
            component="button" 
            variant="body2" 
            onClick={() => navigate('/login')}
            sx={{ color: '#666', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
          >
            Back to Login
          </Link>
        </Box>
      </Paper>
    </Box>
  );
};

export default ForgotPasswordPage;